import { Component, Input } from '@angular/core';

@Component({
  selector: 'profile',
  templateUrl: './profile.html',
  styleUrls:['./profile.scss'] 
})

export class Profile {
    @Input() user: any;
    public invoiceStatusLabels = ['Unknown', 'None', 'Pending', 'Rejected', 'Approved'];

    constructor() {

    }
}


// WEBPACK FOOTER //
// /Users/gordan.o@nylas.com/Documents/GitHub/adluux/adluux-frontend/src/app/pages/admin/users/profile.ts